(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["button-row-auto"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  init(document);
});

// Shopify's theme editor re-renders a section's markup over AJAX whenever a
// setting is changed in the sidebar (or a section is added/moved) — it does
// NOT re-fire DOMContentLoaded, and it swaps in a fresh DOM node for that
// section. The original version of this script only ran once, at
// DOMContentLoaded: once the editor replaced a section's markup, the old
// listeners were left bound to a now-detached node (doing nothing), and the
// freshly-inserted node had no listeners at all — which is exactly why
// editing any setting made the button row appear to "break"/empty out, and
// why clicks sometimes silently did nothing after an edit. Re-running init()
// on every 'shopify:section:load' fixes this by (re)binding whatever section
// was actually just (re)inserted.
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    refreshAllAutoSections();
  });
  document.addEventListener('shopify:section:unload', refreshAllAutoSections);
  document.addEventListener('shopify:section:reorder', refreshAllAutoSections);
}

// Rebuilds the button list (without re-binding drag/hint listeners) for
// every already-initialized button row on the page. Used when some OTHER
// section (e.g. a Collection list section elsewhere on the page) loads,
// unloads, or reorders — our own section didn't reload, but its list of
// targets may have changed.
function refreshAllAutoSections() {
  document.querySelectorAll('.btnrow-auto-section[data-btnrow-auto-initialized]').forEach(function (section) {
    var track = section.querySelector('[data-btnrow-auto-track]');
    if (track && track._btnrowAutoBuildButtons) track._btnrowAutoBuildButtons();
  });
}

function init(scope) {
  var root = scope || document;
  var sections = (root.nodeType === 1 && root.classList && root.classList.contains('btnrow-auto-section'))
    ? [root]
    : Array.prototype.slice.call(root.querySelectorAll ? root.querySelectorAll('.btnrow-auto-section') : []);

  sections.forEach(function (section) {
    var track = section.querySelector('[data-btnrow-auto-track]');
    if (!track) return;

    // Already initialized and still the same live node (Shopify sometimes
    // patches a section in place instead of replacing it) — just rebuild
    // the button list, don't rebind everything a second time.
    if (section.getAttribute('data-btnrow-auto-initialized') === 'true' && track._btnrowAutoBuildButtons) {
      track._btnrowAutoBuildButtons();
      return;
    }

    var showIcon = section.dataset.showIcon === 'true';
    var iconPosition = section.dataset.iconPosition || 'end';
    var scrollOffsetExtra = parseInt(section.dataset.scrollOffsetExtra, 10) || 0;
    var iconTemplate = document.querySelector('template[data-btnrow-auto-icon-template]');

    var dragEnabled = section.dataset.dragScroll === 'true';
    var hintEnabled = section.dataset.scrollHint === 'true';

    function getHeaderOffset() {
      var headerGroup = document.querySelector('.shopify-section-group-header-group');
      if (!headerGroup) return 0;
      var cs = window.getComputedStyle(headerGroup);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        return headerGroup.getBoundingClientRect().height;
      }
      return 0;
    }

    // Scrolling approach, and why it's a plain scrollIntoView rather than a
    // hand-rolled animation: this theme scrolls an inner ".page-wrapper" div
    // rather than the window, and something in the theme (the sticky
    // header's show/hide-on-scroll logic, most likely) cancels a native
    // `scrollIntoView({behavior:'smooth'})` animation after only a few
    // pixels, and a JS-driven, timer-stepped re-implementation of that
    // animation turned out to be unreliable too (its timing depends on the
    // tab/browser not throttling background timers, which isn't guaranteed).
    // A single `scrollIntoView({behavior:'instant'})` call is the one thing
    // that has proven reliable in every test — it jumps straight there with
    // no animation, but it always lands in the right place. The header
    // offset is applied via a temporary `scroll-margin-top` on the target,
    // which `scrollIntoView` respects natively.
    function smoothScrollTo(targetEl) {
      var offset = getHeaderOffset() + scrollOffsetExtra;
      targetEl.style.scrollMarginTop = offset + 'px';
      targetEl.scrollIntoView({ behavior: 'instant', block: 'start' });

      if (history.pushState) {
        history.pushState(null, '', '#' + targetEl.id);
      }
    }

    function collectTargets() {
      var targets = [];
      document.querySelectorAll('.shopify-section.ui-test-collection-list').forEach(function (targetSection) {
        var contentArea = targetSection.querySelector('.section-resource-list__content');
        var heading = contentArea ? contentArea.querySelector('h1, h2, h3, h4, h5, h6') : null;
        var label = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
        if (!label) return; // skip sections without a visible heading
        targets.push({ id: targetSection.id, label: label });
      });
      return targets;
    }

    function buildButtons() {
      var targets = collectTargets();
      track.innerHTML = '';

      targets.forEach(function (target) {
        var item = document.createElement('div');
        item.className = 'btnrow-auto-item';
        item.setAttribute('role', 'listitem');

        var link = document.createElement('a');
        link.href = '#' + target.id;
        link.className = 'btnrow-auto-btn';

        function appendIcon() {
          if (showIcon && iconTemplate) {
            var icon = document.createElement('span');
            icon.className = 'btnrow-auto-icon';
            icon.appendChild(iconTemplate.content.cloneNode(true));
            link.appendChild(icon);
          }
        }

        if (showIcon && iconPosition === 'start') appendIcon();

        var labelEl = document.createElement('span');
        labelEl.className = 'btnrow-auto-label';
        labelEl.textContent = target.label;
        link.appendChild(labelEl);

        if (showIcon && iconPosition !== 'start') appendIcon();

        link.addEventListener('click', function (e) {
          e.preventDefault();
          var targetEl = document.getElementById(target.id);
          if (targetEl) smoothScrollTo(targetEl);
        });

        item.appendChild(link);
        track.appendChild(item);
      });

      setupDragAndHints();
    }

    // Expose so a sibling section reloading (e.g. a Collection list section
    // elsewhere on the page) can ask us to rebuild without re-binding drag.
    track._btnrowAutoBuildButtons = buildButtons;

    function updateHints() {
      if (!hintEnabled) return;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      var overflowing = track.scrollWidth > track.clientWidth + 2;
      section.classList.toggle('btnrow-auto-section--show-fade-start', overflowing && !atStart);
      section.classList.toggle('btnrow-auto-section--show-fade-end', overflowing && !atEnd);
    }

    var dragListenersBound = false;
    function setupDragAndHints() {
      updateHints();

      if (dragListenersBound) return;
      dragListenersBound = true;

      track.addEventListener('scroll', updateHints, { passive: true });
      window.addEventListener('resize', updateHints);

      if (!dragEnabled) return;

      var isDown = false;
      var startX = 0;
      var startScroll = 0;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; // native touch scroll handles this
        isDown = true;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.setPointerCapture(e.pointerId);
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        track.scrollLeft = startScroll - dx;
      });

      function stopDrag() {
        isDown = false;
      }

      track.addEventListener('pointerup', stopDrag);
      track.addEventListener('pointercancel', stopDrag);
      track.addEventListener('pointerleave', stopDrag);

      track.addEventListener('click', function (e) {
        var link = e.target.closest('a');
        if (!link) return;
        if (Math.abs(track.scrollLeft - startScroll) > 5) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);
    }

    buildButtons();
    section.setAttribute('data-btnrow-auto-initialized', 'true');
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["button-row"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.btnrow-section').forEach(function (section) {
    var track = section.querySelector('.btnrow-track');
    if (!track) return;

    var dragEnabled = section.dataset.dragScroll === 'true';
    var hintEnabled = section.dataset.scrollHint === 'true';

    function updateHints() {
      if (!hintEnabled) return;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      var overflowing = track.scrollWidth > track.clientWidth + 2;
      section.classList.toggle('btnrow-section--show-fade-start', overflowing && !atStart);
      section.classList.toggle('btnrow-section--show-fade-end', overflowing && !atEnd);
    }

    updateHints();
    track.addEventListener('scroll', updateHints, { passive: true });
    window.addEventListener('resize', updateHints);

    if (!dragEnabled) return;

    var isDown = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // native touch scroll handles this
      isDown = true;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      track.scrollLeft = startScroll - dx;
    });

    function stopDrag() {
      isDown = false;
    }

    track.addEventListener('pointerup', stopDrag);
    track.addEventListener('pointercancel', stopDrag);
    track.addEventListener('pointerleave', stopDrag);

    track.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (Math.abs(track.scrollLeft - startScroll) > 5) {
          e.preventDefault();
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.hiw-section[data-animate="true"]');
  if (!sections.length) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-hiw-step]').forEach(function (step) {
      step.classList.add('hiw-in-view');
    });
    return;
  }

  sections.forEach(function (section) {
    var steps = section.querySelectorAll('[data-hiw-step]');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hiw-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
    );
    steps.forEach(function (step) {
      observer.observe(step);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
